export default __webpack_public_path__ + "static/media/help-hotlines-illustration.f8ff8807.png";